import store from '../store'
//加载外部js
export function loadJs(src) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.type = "text/javascript";
    script.src = src;
    document.body.appendChild(script);
    script.onload = ()=>{
      resolve();
    }
    script.onerror = ()=>{
      reject();
    }
  })
}

//拨号
export function overallCallWebRtc(phone, case_id) {
  if (!store.getters.isRegistered || store.getters.iscalling || store.getters.isincall) {
    return false
  }
  let options = {
    phone: phone
  }
  if (case_id && case_id != '') {
    options.params = String(case_id)
  }
  webrtcSDK.callPhone(options)
}

/**
* 参数处理
* @param {*} params  参数
*/
export function filterParams(params) {
  for (const key in params) {
    const ele = params[key]
    if (params.hasOwnProperty(key)) {
      if (ele instanceof Array && ele.length == 2) {
        if (ele.every(val => !val)) {
          delete params[key]
        } else {
          params[key] = String(params[key])
        }
      }
      if (params[key] === undefined || params[key] === null || params[key] === '') {
        delete params[key]
      }
    }
  }
  return params
}


// WEBPACK FOOTER //
// ./src/api/utils.js